export default {
    'confirm-dialog': ''
}